import React from 'react';
import { toast } from 'react-toastify';
import { IntlShape, injectIntl } from 'react-intl';
import { StyledDiv } from 'containers/ExpertExpertise/Dialogs/styles';
import DialogMission from 'containers/ExpertExpertise/Dialogs/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerFeeNote/messages';
import { get } from 'lodash';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import { STATUS_PENDING } from 'containers/LawyerFeeNote/constants';

export interface FeeNoteUpdateStatusDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  feeNote: FeeNote;
  viewByClaim: boolean;
  pageSize: any;
  claimNumber: string;
  page: any;
  requestFeeNotes: Function;
}

const FeeNoteUpdateStatusDialog: React.FC<FeeNoteUpdateStatusDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;

  /* istanbul ignore next */
  const successCallBack = () => {
    toast.success(translate(messages.succesDialogUpdateStatus, props));
    props.onClose();
    if (props.viewByClaim) {
      props.requestFeeNotes(props.claimNumber);
    } else {
      props.requestFeeNotes(STATUS_PENDING, props.page, props.pageSize);
    }
  };

  /* istanbul ignore next */
  const onSubmit = () => {
    props.validateDialog(
      {
        id: get(props.feeNote, 'id'),
        status: 'PENDING',
      },
      successCallBack,
    );
  };

  return (
    <DialogMission
      open={open}
      onClose={onClose}
      validateDialog={onSubmit}
      title={translate({ ...messages.feeNoteDialogChangeStatus }, props)}
      content={
        <StyledDiv>
          <>
            {translate({ ...messages.feeNoteDialogChangeDescription }, props)}
          </>
        </StyledDiv>
      }
      disabled={false}
    />
  );
};

FeeNoteUpdateStatusDialog.defaultProps = {
  open: false,
};

export default injectIntl(FeeNoteUpdateStatusDialog);
